export default "__VITE_ASSET__BEhuFJje__"